import i from 'i18next'
import Head from 'next/head'
import { res } from './Image'

type Props = {
	page: string
}

/** Page title tag with fallback string */
export default function Title({ page }: Props ) {
	const title = i.t(
		[ `title.${page}`, 'title.generic' ],
		{ page: i.t( `nav.${page}` ), suffix: i.t( 'title.suffix' ) }
	)
	const description = i.t(
		[ `title.description.${page}`, 'title.description.generic' ]
	)

	return (
		<Head>
			<title>{title}</title>
			<meta property="og:title" content={title} />
			<meta name="description" content={description} />
			<meta property="twitter:description" content={description} />

			{i.exists( `og:image.${page}` ) && (
				<>
					<meta name="twitter:card" content="summary_large_image" />
					<meta
						property="og:image"
						content={res( i.t( `og:image.${page}` ), '1200x628_crop_center' )}
					/>
					<meta property="og:image:width" content="1200" />
					<meta property="og:image:height" content="628" />
				</>
			)}
		</Head>
	)
}
